import { useTimeRangeStore } from '@/store/app.store';
import { TimeRange } from '@/services/dashboard-service/dashboard.service.types';

export type TimeRangeSelection = {
  time_range?: TimeRange;
  start_time?: string;
  end_time?: string;
};

/** The store is the single source of truth for the selected range. */
export function useTimeRangeSelection(): TimeRangeSelection {
  const { timeRange, startTime, endTime } = useTimeRangeStore();

  return {
    time_range: timeRange as TimeRange | undefined,
    start_time: startTime,
    end_time: endTime,
  };
}
